/** @jsx jsx */
import {
  Flex,
  FlexOwnProps,
  FlexProps,
  jsx,
} from "theme-ui";
import React, { CSSProperties } from "react";

export type FlexColProps = {
  justifyContent?: CSSProperties["justifyContent"][];
  justifyItems?: CSSProperties["justifyItems"][];
  alignItems?: CSSProperties["alignItems"][];
} & FlexOwnProps &
  FlexProps;
export const FlexCol: React.FC<FlexColProps> = (props) => {
  /*   const justifyContent = props.justifyContent
      ? props.justifyContent
      : ["flex-start"];
    const alignItems = props.alignItems ? props.alignItems : ["flex-start"];
    const justifyItems = props.justifyItems ? props.justifyItems : ["flex-start"]; */

  const { justifyContent, justifyItems, alignItems, ...otherProps } = props

  return (
    <Flex
      sx={{
        flexDirection: "column",
        justifyContent: justifyContent || ["flex-start"],
        justifyItems: justifyItems || ["flex-start"],
        alignItems: alignItems || ["flex-start"],
      }}
      {...otherProps}
    ></Flex>
  );
};

export const FlexRow: React.FC<FlexColProps> = (props) => {
  /*  const justifyContent = props.justifyContent
     ? props.justifyContent
     : ["flex-start"];
   const alignItems = props.alignItems ? props.alignItems : ["flex-start"]; */
  const { justifyContent, justifyItems, alignItems, ...otherProps } = props
  return (
    <Flex
      sx={{
        flexDirection: "row",
        justifyContent: justifyContent || ["flex-start"],
        alignItems: alignItems || ["flex-start"],
      }}
      {...otherProps}
    ></Flex>
  );
};

export default FlexCol;
